"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tab = function (_React$PureComponent) {
  _inherits(Tab, _React$PureComponent);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isCommingled = this.props.fundTypeCode === "Commingled";

      return _react2.default.createElement(
        "li",
        { className: "" + (isCommingled ? "padding-all-8" : "padding-all-10"),
          role: "presentation" },
        _react2.default.createElement(
          "a",
          { className: "text-center font-regular tag outline-none " + (this.props.isActive ? 'active' : ''),
            href: "#" + this.props.name,
            "data-toggle": "pill",
            "data-tab-name": this.props.name,
            "aria-controls": this.props.name,
            "aria-selected": "" + (this.props.isActive ? true : false),
            "data-testid": this.props.name,
            id: this.props.name + '-tab',
            onClick: function onClick(e) {
              return _this2.props.clickHandler(e);
            },
            role: "tab", tabIndex: this.props.isActive ? '0' : '-1',
            onKeyDown: function onKeyDown(e) {
              var els = document.querySelectorAll('[data-testid="regular-header-div-test"] [role="tab"]');
              var index = 0;
              for (var i = 0; i < els.length; i++) {
                if (els[i].getAttribute("id") === _this2.props.name + '-tab') {
                  index = i;
                  break;
                }
              }

              if (e.key === "ArrowLeft") {
                index--;
                if (index < 0) {
                  index = els.length - 1;
                }
                els[index].focus();
              } else if (e.key === "ArrowRight") {
                index++;
                if (index > els.length - 1) {
                  index = 0;
                }
                els[index].focus();
              } else if (e.key === "Enter") {
                els[index].click();
                for (var j = 0; j < els.length; j++) {
                  if (index !== j) {
                    els[j].setAttribute('tabindex', '-1');
                  } else {
                    els[j].setAttribute('tabindex', '0');
                  }
                }
              } else if (e.key === "Home") {
                els[0].focus();
              } else if (e.key === "End") {
                els[els.length - 1].focus();
              }
            } },
          this.props.label
        )
      );
    }
  }]);

  return Tab;
}(_react2.default.PureComponent);

exports.default = Tab;